import React, { useState, useEffect } from "react"; 
import FadeLoader from "react-spinners/FadeLoader";
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import './SelectPricingPlan.css';
import ValidationMessages from "../utils/validationMessages";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const SelectPricingPlan=({
    setIsSelectPricingOpen,
    entityId,
    parkingLotId,
    currentPlanId,
    handleCancelSelectPricing,
    onConfirmSuccess
})=> {
 const [rowsData, setRowsData] = useState([]);
 const [loader, setLoader] = useState(false);
 const [selectedPlanId, setSelectedPlanId] = useState(null);
 const [submitting, setSubmitting] = useState(false);
 const [open, setOpen] = useState(false);
 const [rowData, setRowData] = useState([]);

 const hostPath = process.env.REACT_APP_API_BASE_URL;
 const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;

  const dayMap = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday"
    };

  const fetchPricingPlans = async () => {
    setLoader(true);
        try {
            const response = await fetch(`${hostPath}/api/GetAllPricingPlans`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "x-functions-key": `${hostHeader}`
                },
             
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            const formattedData = data.map(item => ({
                id: item.id,
                pricingPlanID: item.pricingPlanID,
                pricingPlanName: item.pricingPlanName,
                occurrence: item.occurrence,
                price: item.price,
                rateUnit: item.rateUnit,
                location: item.location,
                timeRanges: item.timeRanges,
                isDefault: item.isDefault,
                status: item.status,
                createdDate: item.createdDate,
                lastUpdatedDate: item.lastUpdatedDate
                }));
            setRowsData(formattedData);
                       
        }
         catch (error) {
            console.error("Error fetching pricing plans:", error);
        }
        finally {
            setLoader(false);
        }
    };

    const handleRadioChange = (e, planId) => {
        e.stopPropagation();
        setSelectedPlanId(planId);
    };


    useEffect(() => {
            setLoader(true);
            fetchPricingPlans();
        }, []);

    useEffect(() => {
    if (currentPlanId) {
      setSelectedPlanId(currentPlanId); 
    }
    }, [currentPlanId]);

    const handleSubmit = () => {
        if (!selectedPlanId) return;

        const selectedPlan = rowsData.find(
        (p) => p.pricingPlanID === selectedPlanId
        );

        const data = {
        message: ValidationMessages.confirmPricing,
        message2: ValidationMessages.confirmContinue,
        status: "confirm",
        val: selectedPlan,
        };

        setRowData(data);
        setOpen(true);
    };
    
       
    const handleConfirm =async(text,status, val)=>{
        setLoader(true);
        if (text === 'confirm'){
            setOpen(false);
            setSubmitting(true);

            const payload = {
            EntityRegistrationID: entityId,
            PricingPlanID: selectedPlanId,
            };

            if (parkingLotId) {
            payload.ParkingLotID = parkingLotId;
            }

            try {
            const response = await fetch(`${hostPath}/api/AssignPricingPlan`, {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                "x-functions-key": `${hostHeader}`,
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            if (onConfirmSuccess) onConfirmSuccess();
           
            setIsSelectPricingOpen(false);
            setSelectedPlanId(null);
            } catch (error) {
            console.error("Error assigning pricing plan:", error);
            } finally {
            setSubmitting(false);
            setLoader(false);
            }
        }
        else if (text === 'cancel') {
                setOpen(false);
            }  
    };
     

return(
<>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}

            <div className="select-pricing-container">
                <div className="select-pricing-header">
                   <h5 style={{ color: 'black' }}>Select Pricing Plan</h5>
                </div>
            </div>
            
            <TableContainer component={Paper} sx={{ maxHeight: '505px', overflow: 'auto',width: '900px' }}>
                <Table sx={{ tableLayout: "fixed", width: "100%" }} aria-label="Select pricing table">
                    <TableHead>
                        <TableRow>
                            {/* <TableCell sx={{ tableLayout: "fixed", width: '5px', padding: '0 8px' }}></TableCell> */}
                            <TableCell sx={{ width: '30%' }}>Pricing Plan</TableCell>
                            <TableCell sx={{ width: '30%' }}>Occurrence</TableCell>
                            <TableCell sx={{ width: '20%' }}>Price</TableCell>
                            <TableCell sx={{ width: '20%' }}>Location</TableCell>
                            {/* <TableCell>Action</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rowsData.length > 0 ? (
                            rowsData.map((row) => (
                                <TableRow key={row.pricingPlanID}>
                                    <TableCell align="left" sx={{ verticalAlign: 'middle',whiteSpace: 'nowrap' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
                                           {row.status !== "Inactive" ? (
                                                        <input
                                                        type="radio"
                                                        name="selectedPlan"
                                                        value={row.pricingPlanID}
                                                        checked={selectedPlanId === row.pricingPlanID}
                                                        onClick={(e) => e.stopPropagation()}
                                                        onChange={(e) => handleRadioChange(e, row.pricingPlanID)}
                                                        style={{
                                                                transform: 'scale(1.2)',
                                                                cursor: 'pointer',
                                                                flexShrink: 0,
                                                                width: '32px'
                                                            }}
                                                        />
                                                        ) : (
                                                        <span style={{ width: '32px', display: 'inline-block' }} />
                                                        )}
                                                        <span>
                                                            {row.pricingPlanName}
                                                        </span>
                                                        {row.isDefault && (
                                                            <span className="default-badge">Default</span>
                                                        )}
                                        </div>
                                    </TableCell>
                                    <TableCell align="center" sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{row.occurrence.map(dayNum => dayMap[dayNum]).join(', ')}</TableCell>
                                    <TableCell align="center">{'$'+row.price+'/'+row.rateUnit}</TableCell>
                                    <TableCell align="center">{row.location}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    No Pricing Plans Found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <div className="select-pricing-buttons">
                    <button className="cancel-btn" onClick={handleCancelSelectPricing}>
                        Cancel
                    </button>
                    <button
                        className="select-pricing-btn"
                            onClick={handleSubmit}
                            disabled={submitting || !selectedPlanId}
                            style={{
                                cursor: submitting || !selectedPlanId ? "not-allowed" : "pointer",
                            }}
                    >
                        {"Confirm"}
                    </button>
            </div>

            
            
            <Dialog classes={{ paper: 'custom-paper-class-delete' }}
                        aria-labelledby="customized-dialog-title"
                        dividers
                        open={open}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                <DialogTitle dividers sx={{ textAlign: 'start', color: "#000;", fontSize: "24px", fontWeight: "700", padding: "5px 24px " }} id="customized-dialog-title">
                            {rowData?.message}  
                </DialogTitle>
                <DialogContent style={{ border: "none", padding: "5px 22px", color: "#000;" }}>
                            <Typography gutterBottom>
                                <span>{rowData?.message2}</span>
                            </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'right' }}>
                            <Button
                                className='custom-button-cancel'
                                onClick={() => handleConfirm('cancel')}
                            >
                                Cancel
                            </Button>
                            <Button
                                className='custom-button-delete'
                                onClick={() => handleConfirm('confirm',rowData?.status, rowData?.val)}
                            >
                                Confirm
                            </Button>
                </DialogActions>
            </Dialog>
        </>
);
}
export default SelectPricingPlan;